import { gql } from '@apollo/client';

export const CbPromoCodeFields = gql`
  fragment CbPromoCodeFields on CbPromoCode {
    id
    code
    kind
    status
    isActive
    startsAt
    expiresAt
    totalUses
    usedCount
    remainingUses
    perAccountLimit
    note
    performedByEmail
    performedById
    performedByName
    createdAt
    updatedAt
    ... on CbCreditFreePromoCode {
      creditAmount
      promoIssuedTotal
    }
    ... on CbCreditMatchPromoCode {
      matchPercent
      maxPromoPerRedemption
      promoIssuedTotal
    }
    ... on CbSubscriptionDiscountPromoCode {
      percentOff
      discountDuration
      discountDurationMonths
      discountGrantedTotal
      applicableTargets {
        product
        recurrence
      }
    }
    ... on CbSubscriptionTrialPromoCode {
      trialDays
      applicableTargets {
        product
        recurrence
      }
      trialMetrics {
        trialsStarted
        trialsInProgress
        trialsConverted
        conversionRate
      }
    }
  }
`;

export const CbPromoCodeRedemptionFields = gql`
  fragment CbPromoCodeRedemptionFields on CbPromoCodeRedemption {
    id
    promoCodeId
    ownerId
    teamId
    subscriptionId
    stripeCouponId
    balanceTransactionId
    creditAmountGranted
    performedByEmail
    performedById
    performedByName
    createdAt
  }
`;
